<template>
  <div class="smartphone">
    <div class="content h-full">
      <slot></slot>
    </div>
  </div>
</template>

<script>
/**
 * Phone device preview with slot content
 *
 * @module views/modules/components/PhonePreview
 * @author Dilan Useche <dilan8810@gmail.com>
 */
export default {
  name: 'PhonePreview',
};
</script>

<style lang="scss" scoped>
/* The device with borders */
.smartphone {
  position: relative;
  min-width: 280px;
  max-width: 345px;
  height: 650px;
  margin: auto;
  border: 20px rgba(var(--vs-grey-light), 1) solid;
  border-top-width: 30px;
  border-bottom-width: 30px;
  border-radius: 36px;
}

/* The horizontal line on the top of the device */
/*.smartphone:before {
  content: '';
  display: block;
  width: 60px;
  height: 5px;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #333;
  border-radius: 10px;
}*/

/* The circle on the bottom of the device */
/*.smartphone:after {
  content: '';
  display: block;
  width: 35px;
  height: 35px;
  position: absolute;
  left: 50%;
  bottom: -65px;
  transform: translate(-50%, -50%);
  background: #333;
  border-radius: 50%;
}*/

/* The screen (or content) of the device */
.smartphone .content {
  width: 100%; /* Asegura que ocupe toda la pantalla */
  min-height: 100%; /* Asegura altura completa */
  height: auto;
  overflow-y: auto; /* Permite scroll si el contenido es extenso */
  background: white; /* Fondo del teléfono */
  display: flex; /* Ajusta el contenido centrado */
  flex-direction: column;
  justify-content: flex-start;
}
</style>
